module.exports = __webpack_public_path__ + "img/behance-icon.2186eac1.svg";